import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import "./buttons.css";


const GOOGLE_CLIENT_ID = "929355544554-n6pcgh47h275rv9h3moj973s4f0j923o.apps.googleusercontent.com";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </GoogleOAuthProvider>
);

// Register service worker for PWA
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    const isKiosk = window.location.pathname.includes("/attendance/kiosk");

    // When a new service worker takes control, the app code on the page is
    // stale. On the unattended check-in kiosk, reload automatically so new
    // deploys apply without anyone having to clear Safari. (Elsewhere we show
    // a gentle toast so we don't interrupt someone mid-task.)
    let refreshing = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (refreshing) return;
      refreshing = true;
      if (isKiosk) window.location.reload();
    });

    navigator.serviceWorker.register("/sw.js").then((registration) => {
      // Check for updates often on the kiosk, less often elsewhere
      setInterval(() => registration.update(), (isKiosk ? 1 : 5) * 60 * 1000);

      registration.addEventListener("updatefound", () => {
        const newWorker = registration.installing;
        if (newWorker) {
          newWorker.addEventListener("statechange", () => {
            if (newWorker.state === "activated" && navigator.serviceWorker.controller) {
              if (isKiosk) {
                // Kiosk: just refresh to the new version
                window.location.reload();
                return;
              }
              // New version available - show a subtle toast
              const toast = document.createElement("div");
              toast.innerHTML = "Update available &mdash; <b>tap to refresh</b>";
              toast.style.cssText =
                "position:fixed;bottom:20px;left:50%;transform:translateX(-50%);background:#0f2b5e;" +
                "color:#fff;padding:12px 24px;border-radius:10px;font-size:14px;z-index:99999;" +
                "cursor:pointer;box-shadow:0 4px 20px rgba(0,0,0,0.3);text-align:center;";
              toast.onclick = () => window.location.reload();
              document.body.appendChild(toast);
              // Auto-dismiss after 30 seconds
              setTimeout(() => toast.remove(), 30000);
            }
          });
        }
      });
    }).catch((err) => {
      console.log("SW registration failed:", err);
    });
  });
}
